import { orderParserClient } from './client'
import type { ServiceConfigParam, OrderParserAuditLog } from '../types'

export const getOrderParserConfig = () =>
  orderParserClient.get<ServiceConfigParam[]>('/config')

export const setOrderParserConfig = (key: string, value: string) =>
  orderParserClient.post('/config', { [key]: value })

export const getOrderParserAuditLogs = (params?: { action?: string; documentId?: string; limit?: number }) =>
  orderParserClient.get<OrderParserAuditLog[]>('/audit-logs', { params })
